import { useState } from "react";
import TextInput from "../TextInput";
import { TextFieldProps } from "@mui/material";

interface Props extends Omit<TextFieldProps<"outlined">, 'variant'> {
  id: string;
  value: any;
  handleFormItem: any;
  label?: string
}

export default function SingleMetricInput(props: Props) {
  const { id, value, handleFormItem, ...rest } = props;

  const [isFocused, setFocused] = useState<boolean>(false);

  return (
    <TextInput
      {...rest}
      onChange={(e) =>
        handleFormItem(
          e.target.value
            ?.replace(",", ".")
            ?.replace(/[^0-9.]+/g, "")
            ?.replace(/(\..*)\./g, "$1")
            ?.replace("%", ""),
          id
        )
      }
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      value={value ? `${value}${!isFocused ? "%" : ""}` : ""}
      variant="outlined"
    />
  );
}
